import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "./../../axios";
import { timeHelper, dateHelper } from "../../Utils/datetime_helper";
import { toast } from "react-toastify";
import {
  BookType,
  Calendar,
  ClockFadingIcon,
  Trophy,
  FileText,
  MessageSquare,
  Layers,
  Target,
  ArrowLeft,
  Save,
  Check,
  Loader2,
} from "lucide-react";
import {
  Dialog,
  DialogContent,
  CircularProgress,
  Typography,
  Box,
  LinearProgress,
} from "@mui/material";

function DraftCompetencyReport() {
  const location = useLocation();
  const navigate = useNavigate();

  // State se data utha rahe hain jo Edit se aaya
  const { state } = location;
  const competencyDetails =
    state?.competencyDetails || state?.assessment || null;

  console.log(competencyDetails, "Asdkandsadas");
  const competencyIdParam = state?.assessmentId || competencyDetails?._id;

  // ─── States ──────────────────────────────────────
  const [loadingData, setLoadingData] = useState(true);
  const [competencyData, setCompetencyData] = useState(competencyDetails); // For Evaluation Details
  const [studentList, setStudentList] = useState([]); // For Students

  const [isInProgress, setIsInProgress] = useState(false);
  const [disableButton, setDisableButton] = useState(false);
  const [showLoadingDialog, setShowLoadingDialog] = useState(false);
  const [loadingMessage, setLoadingMessage] = useState("");
  const [loadingProgress, setLoadingProgress] = useState(0);
  const [totalStudents, setTotalStudents] = useState(0);

  // ─── Local Storage Data ──────────────────────────
  const schoolId = JSON.parse(localStorage.getItem("schoolId"));
  const teacherId = JSON.parse(localStorage.getItem("Teacher_id"));
  const academicSessionId = JSON.parse(
    localStorage.getItem("academicYearSessionId"),
  );
  const timeTableSessionId = JSON.parse(
    localStorage.getItem("timeTableSessionId"),
  );

  // ─── Extract Competency Details ──────────────────
  const rubricDetails = competencyData?.rubricScaleId;

  const evaluationTypeName = competencyData?.evaluationTypeId?.name;

  console.log(evaluationTypeName, "Asdkan");
  const evaluationTypeId = competencyData?.evaluationTypeId?.id;

  const hasRubrics =
    evaluationTypeName?.toLowerCase().includes("rubrics") && rubricDetails;
  const hasRemarks = evaluationTypeName?.toLowerCase().includes("remarks");
  const rubricItems = rubricDetails?.rubricItems || [];

  // ─── Fetch BOTH APIs on Mount ────────────────────
  useEffect(() => {
    const fetchData = async () => {
      if (!competencyIdParam) {
        toast.error("No Competency ID found!");
        setLoadingData(false);
        return;
      }

      try {
        // 1️⃣ API 1: GET COMPETENCY EVALUATION DETAILS
        console.log(
          "🔵 Fetching Competency Evaluation Details ID:",
          competencyIdParam,
        );
        const evalRes = await axios.get(
          `/api/v1/competency/evaluations/${competencyIdParam}`,
        );
        console.log("✅ Evaluation API Response:", evalRes?.data);

        if (evalRes?.data?.success) {
          const fetchedEvalData =
            evalRes?.data?.data?.evaluation || evalRes?.data?.data || null;
          if (fetchedEvalData) {
            setCompetencyData((prev) => ({ ...prev, ...fetchedEvalData }));
          }
        }

        // 2️⃣ API 2: GET STUDENTS
        console.log("🔵 Fetching Students for ID:", competencyIdParam);
        const studentRes = await axios.get(
          `/api/v1/competency/evaluations/${competencyIdParam}/students`,
        );
        console.log("✅ Students API Response:", studentRes?.data);

        // Extract students array safely
        const studentData =
          studentRes?.data?.data?.students || studentRes?.data?.data || [];

        // Map to UI format and PRE-FILL rubricValues if they exist
        const students = studentData.map((student) => ({
          id: student.studentId,
          name: student.name || "Unknown",
          rollNumber: student.rollNo || "-",
          // 🔥 Pre-fill logic: Agar API mein value hai toh dikhao, warna empty rakho
          rubricValue: student.rubricValue || "",
          remark: student.remark || "",
        }));

        // ✅ Sort by Roll Number (1, 2, 3... 10, 11)
        students.sort((a, b) => {
          const numA = parseFloat(a.rollNumber) || 0;
          const numB = parseFloat(b.rollNumber) || 0;
          return numA - numB;
        });

        setStudentList(students);
        setTotalStudents(students.length);
      } catch (error) {
        console.error("❌ Error fetching draft data:", error);
        toast.error(
          error?.response?.data?.message || "Failed to load draft data",
        );
      } finally {
        setLoadingData(false);
      }
    };

    fetchData();
  }, [competencyIdParam]);

  // ─── Handle Input Changes ──────────────────────
  const handleRubricChange = (index, value) => {
    const updatedList = [...studentList];
    updatedList[index].rubricValue = value;
    setStudentList(updatedList);
  };

  const handleRemarkChange = (index, value) => {
    const updatedList = [...studentList];
    updatedList[index].remark = value;
    setStudentList(updatedList);
  };

  // ─── Validate & Submit ──────────────────────────
  const validateSubmission = () => {
    if (hasRubrics) {
      const missing = studentList.filter((s) => !s.rubricValue);
      if (missing.length > 0) {
        toast.warning(
          `Please select rubric for all students (${missing.length} remaining)`,
        );
        return false;
      }
    }
    return true;
  };

  const handleSubmission = async (status) => {
    // Validation commented out as per your requirement
    // if (!validateSubmission()) return;

    if (!competencyIdParam) {
      toast.error("Missing Evaluation ID!");
      return;
    }

    // ─── 1. Setup UI States ──────────────────────────
    setIsInProgress(true);
    setDisableButton(true);
    setShowLoadingDialog(true);
    setLoadingMessage("Saving student evaluations...");
    setLoadingProgress(10);

    try {
      // ─── 2. Add Students to Evaluation ──────────────
      setLoadingProgress(25);
      setLoadingMessage(
        `Adding ${studentList.length} students to evaluation...`,
      );

      const studentIds = studentList.map((student) => student.id);

      const addStudentsPayload = {
        schoolId: schoolId,
        studentIds: studentIds,
      };

      await axios.post(
        `/api/v1/competency/evaluations/${competencyIdParam}/students/add`,
        addStudentsPayload,
      );

      // ─── 3. Save Student Entries ─────────────────────
      setLoadingProgress(50);
      setLoadingMessage(`Saving ${studentList.length} student records...`);

      const studentEntriesPayload = {
        teacherId: teacherId || JSON.parse(localStorage.getItem("Teacher_id")),
        isSubmitComplete: status === "submit", // true for submit, false for draft
        studentEntries: studentList.map((student) => ({
          studentId: student.id,
          rubricValue: hasRubrics ? student.rubricValue : undefined,
          remark: hasRemarks ? student.remark : undefined,
        })),
      };

      // Send Bulk API Call for Students
      await axios.put(
        `/api/v1/competency/evaluations/${competencyIdParam}/student-entries`,
        studentEntriesPayload,
      );

      // ─── 4. Update Evaluation Status (ONLY AFTER Students are saved) ───
      setLoadingProgress(80);
      setLoadingMessage("Updating competency status...");

      const evalPayload = {
        status: status === "submit" ? "completed" : "draft",
      };

      const updateRes = await axios.put(
        `/api/v1/competency/evaluations/${competencyIdParam}`,
        evalPayload,
      );

      if (!updateRes?.data?.success) {
        throw new Error(
          updateRes?.data?.message || "Failed to update competency status",
        );
      }

      // ─── 5. Finalize & Navigate ──────────────────────
      setLoadingProgress(100);
      setLoadingMessage("Finalizing...");
      await new Promise((resolve) => setTimeout(resolve, 600));

      setShowLoadingDialog(false);
      toast.success(
        status === "submit"
          ? "✅ Competency submitted successfully!"
          : "💾 Draft saved successfully!",
        { autoClose: 3000 },
      );

      navigate("/offline-performance/competency");
    } catch (error) {
      console.error("🚨 Submission Error:", error);

      // Agar error aata hai, toh status update nahi hoga, draft hi rahega
      // User ko exact error dikhayenge
      toast.error(
        error?.response?.data?.message ||
          "Failed to save changes. Please try again.",
      );
    } finally {
      // Always reset UI states
      setIsInProgress(false);
      setDisableButton(false);
      setShowLoadingDialog(false);
    }
  };

  // ─── UI Helpers ──────────────────────────────────
  const getColumnCount = () => {
    let count = 2;
    if (hasRubrics) count++;
    if (hasRemarks) count++;
    return count;
  };

  const renderRubricDropdown = (index, student) => {
    return (
      <div style={{ width: "100%" }}>
        <select
          className="form-select"
          value={student.rubricValue || ""}
          onChange={(e) => handleRubricChange(index, e.target.value)}
          style={{
            width: "100%",
            padding: "8px 10px",
            borderRadius: "8px",
            border: "1.5px solid #e2e8f0",
            fontSize: "13px",
            backgroundColor: "#fff",
            cursor: "pointer",
            minHeight: "40px",
            color: student.rubricValue ? "#1e293b" : "#94a3b8",
          }}
        >
          <option value="">Select Rubric Level</option>
          {rubricItems.map((item, idx) => (
            <option key={idx} value={item.value}>
              {item.value}
            </option>
          ))}
        </select>
      </div>
    );
  };

  const renderRemarksInput = (index, student) => {
    return (
      <textarea
        rows="1"
        value={student.remark || ""}
        onChange={(e) => handleRemarkChange(index, e.target.value)}
        placeholder="Enter remark..."
        maxLength={250}
        style={{
          width: "100%",
          padding: "8px 10px",
          borderRadius: "8px",
          border: "1.5px solid #e2e8f0",
          fontSize: "13px",
          resize: "vertical",
          minHeight: "40px",
          backgroundColor: "#fff",
          fontFamily: "inherit",
        }}
      />
    );
  };

  // ─── Loading State ──────────────────────────────
  if (loadingData) {
    return (
      <div
        className="w-100 d-flex justify-content-center align-items-center"
        style={{ minHeight: "300px" }}
      >
        <div className="d-flex flex-column align-items-center gap-2">
          <Loader2 className="spinner-border text-warning" size={30} />
          <span className="text-muted small">Loading Draft Data...</span>
        </div>
      </div>
    );
  }

  // ─── Render UI ──────────────────────────────────
  return (
    <div
      className="w-100 orange-scrollBar"
      style={{ overflowY: "hidden", height: "calc(100vh - 100px)" }}
    >
      {/* ─── Loading Dialog ──────────────────────── */}
      <Dialog
        open={showLoadingDialog}
        disableEscapeKeyDown
        PaperProps={{
          style: {
            borderRadius: "20px",
            padding: "0",
            minWidth: "420px",
            maxWidth: "460px",
            boxShadow: "0 24px 80px rgba(0,0,0,0.18)",
            overflow: "hidden",
          },
        }}
      >
        <DialogContent sx={{ p: 0 }}>
          <Box
            sx={{
              height: "4px",
              width: "100%",
              background:
                "linear-gradient(90deg, #f97316, #fb923c, #fbbf24, #f97316)",
              backgroundSize: "300% 100%",
              animation: "shimmer 2s infinite linear",
            }}
          />
          <Box sx={{ textAlign: "center", py: 1, px: 1 }}>
            <Box sx={{ position: "relative", display: "inline-flex", mb: 1 }}>
              <CircularProgress
                variant="determinate"
                value={loadingProgress}
                size={80}
                thickness={3.5}
                sx={{
                  color: "#f97316",
                  "& .MuiCircularProgress-circle": { strokeLinecap: "round" },
                }}
              />
              <Box
                sx={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexDirection: "column",
                }}
              >
                <Typography
                  variant="h6"
                  sx={{
                    fontWeight: 700,
                    color: "#f97316",
                    fontSize: "18px",
                    lineHeight: 1,
                  }}
                >
                  {loadingProgress}%
                </Typography>
              </Box>
            </Box>
            <Typography
              variant="h6"
              sx={{
                fontWeight: 600,
                color: "#1e293b",
                mb: 0.5,
                fontSize: "17px",
              }}
            >
              {loadingMessage || "Processing..."}
            </Typography>
            <Box sx={{ width: "100%", mb: 1 }}>
              <LinearProgress
                variant="determinate"
                value={loadingProgress}
                sx={{
                  height: 8,
                  borderRadius: "10px",
                  backgroundColor: "#f1f5f9",
                  "& .MuiLinearProgress-bar": {
                    borderRadius: "10px",
                    background: "linear-gradient(90deg, #f97316, #fb923c)",
                    transition: "transform 0.4s ease-in-out",
                  },
                }}
              />
            </Box>
          </Box>
        </DialogContent>
      </Dialog>

      {/* ─── Header ──────────────────────────────── */}
      <div className="mb-3 pt-3">
        <div
          className="d-flex align-items-center gap-2 cursor-pointer"
          style={{ cursor: "pointer" }}
          onClick={() => navigate("/offline-performance/competency")}
        >
          <div>
            <ArrowLeft size={20} color="#64748b" />
          </div>
          <div className="d-flex flex-column gap-1">
            <span
              className="head_manual"
              style={{ fontSize: "18px", fontWeight: 600 }}
            >
              Draft Competency Evaluation
            </span>
            <span className="fw-small text-muted" style={{ fontSize: "10px" }}>
              Dashboard / Performance / Draft Evaluation
            </span>
          </div>
        </div>
      </div>

      {/* ─── Main Card ───────────────────────────── */}
      <div
        className="w-100 py-3 px-4 rounded-3"
        style={{
          backgroundColor: "#fff",
          boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
          display: "flex",
          flexDirection: "column",
          maxHeight: "calc(100vh - 190px)",
        }}
      >
        {/* ─── Top Info Bar ──────────────────────── */}
        <div style={{ flexShrink: 0 }}>
          <div className="class-section-subject d-flex align-items-start flex-column gap-2 ml-3">
            <div className="d-flex align-items-center gap-3 flex-wrap">
              <div
                className="fs-5 poppins-semibold"
                style={{ color: "#1e293b" }}
              >
                <span>
                  {competencyData?.standardId?.name || "N/A"} -{" "}
                  {competencyData?.sectionId?.name || "N/A"}
                </span>
              </div>
              <span
                className="badge"
                style={{
                  backgroundColor: "#6366f1",
                  color: "#fff",
                  fontSize: "11px",
                  fontWeight: 600,
                  padding: "5px 12px",
                  borderRadius: "6px",
                  display: "flex",
                  alignItems: "center",
                  gap: "4px",
                }}
              >
                <Layers size={12} />{" "}
                {competencyData?.domain_id?.name || "Domain"}
              </span>
              <span
                className="badge"
                style={{
                  backgroundColor: "#8b5cf6",
                  color: "#fff",
                  fontSize: "11px",
                  fontWeight: 600,
                  padding: "5px 12px",
                  borderRadius: "6px",
                  display: "flex",
                  alignItems: "center",
                  gap: "4px",
                }}
              >
                <Target size={12} />{" "}
                {competencyData?.competency_id?.name || "Competency"}
              </span>
              <span
                className="badge"
                style={{
                  backgroundColor: "#f77f00",
                  color: "#fff",
                  fontSize: "11px",
                  fontWeight: 600,
                  padding: "5px 12px",
                  borderRadius: "6px",
                  display: "flex",
                  alignItems: "center",
                  gap: "4px",
                }}
              >
                <Trophy size={12} /> {rubricDetails?.name || "Rubric"}
              </span>
              <span
                className="badge"
                style={{
                  backgroundColor:
                    hasRubrics && hasRemarks
                      ? "#0ea5e9"
                      : hasRubrics
                        ? "#10b981"
                        : "#f59e0b",
                  color: "#fff",
                  fontSize: "11px",
                  fontWeight: 600,
                  padding: "5px 12px",
                  borderRadius: "20px",
                }}
              >
                {evaluationTypeName}
              </span>
            </div>

            <div className="d-flex align-items-center w-100 gap-4 flex-wrap mt-1">
              <div
                className="title-text"
                style={{ fontSize: "15px", fontWeight: 600, color: "#334155" }}
              >
                <BookType
                  size={16}
                  className="me-2"
                  style={{ color: "#f77f00" }}
                />{" "}
                {competencyData?.name || "Untitled"}
              </div>
              {competencyData?.schedule_date && (
                <>
                  <div className="d-flex align-items-center gap-2">
                    <Calendar size={16} style={{ color: "#64748b" }} />
                    <span
                      className="poppins-semibold"
                      style={{ fontSize: "13px", color: "#475569" }}
                    >
                      {dateHelper(competencyData.schedule_date)}
                    </span>
                  </div>
                  <div className="d-flex align-items-center gap-2">
                    <ClockFadingIcon size={16} style={{ color: "#64748b" }} />
                    <span
                      className="poppins-semibold"
                      style={{ fontSize: "13px", color: "#475569" }}
                    >
                      {timeHelper(competencyData.schedule_time)}
                    </span>
                  </div>
                </>
              )}
              <div className="d-flex align-items-center gap-2">
                <FileText size={16} style={{ color: "#64748b" }} />
                <span
                  className="poppins-semibold"
                  style={{ fontSize: "13px", color: "#475569" }}
                >
                  {competencyData?.reportCycle_id?.name || "Report Cycle"}
                </span>
              </div>
            </div>
          </div>

          {competencyData?.description && (
            <div className="ml-3 mt-2">
              <div style={{ fontSize: "13px", color: "#64748b" }}>
                <span style={{ fontWeight: 600, color: "#334155" }}>
                  Description:
                </span>{" "}
                {competencyData.description}
              </div>
            </div>
          )}
        </div>

        {/* ─── Student Table ──────────────────────── */}
        <div
          className="mid-student-table"
          style={{ flex: 1, overflowY: "auto", minHeight: 0 }}
        >
          <div className="table-container-offlineSub">
            <div className="scrollable-table-wrapper">
              <table className="student-table-offlineSub">
                <thead style={{ position: "sticky", top: "0", zIndex: 10 }}>
                  <tr>
                    <th style={{ width: "25%" }}>Name</th>
                    <th style={{ width: "15%" }}>Roll No.</th>
                    {hasRubrics && (
                      <th style={{ width: hasRemarks ? "30%" : "50%" }}>
                        <div className="d-flex align-items-center gap-2">
                          <Trophy size={14} /> Rubric Level
                        </div>
                      </th>
                    )}
                    {hasRemarks && (
                      <th style={{ width: hasRubrics ? "30%" : "60%" }}>
                        <div className="d-flex align-items-center gap-2">
                          <MessageSquare size={14} /> Remarks
                        </div>
                      </th>
                    )}
                  </tr>
                </thead>
                <tbody>
                  {studentList.map((student, index) => (
                    <tr key={index}>
                      <td style={{ fontWeight: 500, color: "#1e293b" }}>
                        {student.name}
                      </td>
                      <td style={{ color: "#64748b", fontSize: "13px" }}>
                        {student.rollNumber}
                      </td>
                      {hasRubrics && (
                        <td>{renderRubricDropdown(index, student)}</td>
                      )}
                      {hasRemarks && (
                        <td>{renderRemarksInput(index, student)}</td>
                      )}
                    </tr>
                  ))}
                  {studentList.length === 0 && (
                    <tr>
                      <td
                        colSpan={getColumnCount()}
                        style={{
                          textAlign: "center",
                          padding: "40px",
                          color: "#94a3b8",
                        }}
                      >
                        No students found for this evaluation.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>

        {/* ─── Action Buttons ────────────────────── */}
        <div
          className="d-flex justify-content-end gap-3 mt-1"
          style={{
            flexShrink: 0,
            backgroundColor: "#fff",
            paddingTop: "12px",
            borderTop: "1px solid #f1f5f9",
          }}
        >
          <button
            className="btn d-flex align-items-center justify-content-center gap-2"
            onClick={() => handleSubmission("save")}
            disabled={isInProgress || disableButton}
            style={{
              backgroundColor: "#fff",
              color: "#475569",
              border: "2px solid #e2e8f0",
              width: "140px",
              height: "44px",
              borderRadius: "10px",
              fontWeight: 600,
              fontSize: "14px",
              transition: "all 0.2s ease",
              boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
            }}
            onMouseEnter={(e) => {
              e.target.style.borderColor = "#f77f00";
              e.target.style.color = "#f77f00";
              e.target.style.backgroundColor = "#fff7ed";
            }}
            onMouseLeave={(e) => {
              e.target.style.borderColor = "#e2e8f0";
              e.target.style.color = "#475569";
              e.target.style.backgroundColor = "#fff";
            }}
          >
            <Save size={16} /> Save Draft
          </button>
          <button
            className="btn d-flex align-items-center justify-content-center gap-2"
            onClick={() => handleSubmission("submit")}
            disabled={isInProgress || disableButton}
            style={{
              backgroundColor:
                isInProgress || disableButton ? "#cbd5e1" : "#f77f00",
              color: "white",
              width: "140px",
              height: "44px",
              borderRadius: "10px",
              fontWeight: 600,
              fontSize: "14px",
              border: "none",
              boxShadow:
                isInProgress || disableButton
                  ? "none"
                  : "0 4px 14px rgba(247, 127, 0, 0.35)",
              transition: "all 0.2s ease",
              cursor: isInProgress || disableButton ? "not-allowed" : "pointer",
            }}
            onMouseEnter={(e) => {
              if (!isInProgress && !disableButton) {
                e.target.style.backgroundColor = "#e06b00";
                e.target.style.transform = "translateY(-2px)";
                e.target.style.boxShadow = "0 6px 20px rgba(247, 127, 0, 0.45)";
              }
            }}
            onMouseLeave={(e) => {
              if (!isInProgress && !disableButton) {
                e.target.style.backgroundColor = "#f77f00";
                e.target.style.transform = "translateY(0)";
                e.target.style.boxShadow = "0 4px 14px rgba(247, 127, 0, 0.35)";
              }
            }}
          >
            <Check size={16} strokeWidth={3} /> Submit
          </button>
        </div>
      </div>

      <style jsx>{`
        @keyframes shimmer {
          0% {
            background-position: 200% 0;
          }
          100% {
            background-position: -200% 0;
          }
        }
      `}</style>
    </div>
  );
}

export default DraftCompetencyReport;
